import React from 'react';

import { Icon } from '@/components/memo';
import { fileTrayOutline } from 'ionicons/icons';

import './Empty.css';

interface EmptyProps {
  icon?: string;
  message?: React.ReactNode | string | null;
  marginTop?: number;
}

const Empty: React.FC<EmptyProps> = ({ icon, message, marginTop }) => {
  return (
    <div className="empty" style={{ marginTop }}>
      <Icon icon={icon || fileTrayOutline} className="empty__icon" />
      <p className="empty__message">
        {message || 'Nothing to see here yet...'}
      </p>
    </div>
  );
};

export default Empty;
